import { addMerchToPage } from './utils/addMerchToPage';
import blockUtils from './utils/block';
import colourUtils from './utils/colours';
import { createPageForSide } from './utils/createPageForSide';
import * as teamNameUtils from './utils/customisation/assets/teamNames';
import exclusionUtils from './utils/exclusionZones';
import designUtils from './utils/getArtwork';
import * as graphicUtils from './utils/graphic';
import { loadFromScene } from './utils/loadFromScene';
import { getCurrentDecorationMethod, setDecorationMethod } from './utils/metadata';
import * as neckLabelUtils from './utils/neckLabelBlocks';
import { addArtworkToPage, addBackgroundToPage, getPageScaleFactor } from './utils/page';
import recolourUtils from './utils/recolourTools';
import { getSceneArchive, getSceneString } from './utils/scene';
import { switchToSide } from './utils/switchToSide';
import * as vectorUtils from './utils/vectors';

export const editorTools = {
	addBackgroundToPage,
	addArtworkToPage,
	addMerchToPage,
	getPageScaleFactor,
	createPageForSide,
	switchToSide,
	setDecorationMethod,
	getCurrentDecorationMethod,
	getSceneString,
	getSceneArchive,
	loadFromScene,
	...vectorUtils,
	...teamNameUtils,
	...colourUtils,
	...recolourUtils,
	...blockUtils,
	...designUtils,
	...exclusionUtils,
	...neckLabelUtils,
	...graphicUtils,
};
